import { render, staticRenderFns } from "./HomepageInstructorSection.vue?vue&type=template&id=35bd3e39&scoped=true&"
import script from "./HomepageInstructorSection.vue?vue&type=script&lang=js&"
export * from "./HomepageInstructorSection.vue?vue&type=script&lang=js&"
import style0 from "./HomepageInstructorSection.vue?vue&type=style&index=0&id=35bd3e39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd3e39",
  null
  
)

export default component.exports